import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('rfid_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('rfid_token');
      localStorage.removeItem('rfid_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login          = (data) => api.post('/auth/login', data);
export const getMe          = ()     => api.get('/auth/me');
export const changePassword = (data) => api.post('/auth/change-password', data);

// Users
export const getUsers      = ()       => api.get('/users');
export const createUser    = (data)   => api.post('/users', data);
export const updateUser    = (id, d)  => api.put(`/users/${id}`, d);
export const deleteUser    = (id)     => api.delete(`/users/${id}`);
export const resetPassword = (id, d)  => api.put(`/users/${id}/reset-password`, d);

// Events
export const getEvents       = ()       => api.get('/events');
export const getEvent        = (id)     => api.get(`/events/${id}`);
export const createEvent     = (data)   => api.post('/events', data);
export const updateEvent     = (id, d)  => api.put(`/events/${id}`, d);
export const deleteEvent     = (id)     => api.delete(`/events/${id}`);
export const uploadEventLogo = (id, fd) => api.post(`/events/${id}/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });

// Categories
export const getCategories  = ()       => api.get('/categories');
export const createCategory = (data)   => api.post('/categories', data);
export const updateCategory = (id, d)  => api.put(`/categories/${id}`, d);
export const deleteCategory = (id)     => api.delete(`/categories/${id}`);

// Conference Locations
export const getConfLocations   = (params) => api.get('/conference-locations', { params });
export const createConfLocation = (data)   => api.post('/conference-locations', data);
export const updateConfLocation = (id, d)  => api.put(`/conference-locations/${id}`, d);
export const deleteConfLocation = (id)     => api.delete(`/conference-locations/${id}`);

// Readers
export const getReaders         = (params) => api.get('/readers', { params });
export const getReadersSummary  = ()       => api.get('/readers/summary');
export const createReader       = (data)   => api.post('/readers', data);
export const updateReader       = (id, d)  => api.put(`/readers/${id}`, d);
export const updateReaderStatus = (id, d)  => api.patch(`/readers/${id}/status`, d);
export const deleteReader       = (id)     => api.delete(`/readers/${id}`);

// Delegates
export const getDelegates        = (params) => api.get('/delegates', { params });
export const getDelegate         = (id)     => api.get(`/delegates/${id}`);
export const createDelegate      = (data)   => api.post('/delegates', data);
export const updateDelegate      = (id, d)  => api.put(`/delegates/${id}`, d);
export const deleteDelegate      = (id)     => api.delete(`/delegates/${id}`);
export const bulkImportDelegates = (data)   => api.post('/delegates/bulk-import', data);

// Live Tracking
export const getLiveLocationCounts = (params) => api.get('/live-tracking/location-counts', { params });
export const getLiveDelegates      = (params) => api.get('/live-tracking/delegates', { params });
export const getLiveReaderStatus   = (params) => api.get('/live-tracking/reader-status', { params });
export const getLiveStats          = (params) => api.get('/live-tracking/stats', { params });
export const postScan              = (data)   => api.post('/live-tracking/scan', data);

// Raw Inventory
export const getRawScans    = (params) => api.get('/raw-inventory', { params });
export const getRawReaders  = (params) => api.get('/raw-inventory/readers', { params });
export const deleteRawScans = (data)   => api.delete('/raw-inventory', { data });

// Handheld
export const getHandheldEvents    = ()      => api.get('/handheld/events');
export const getHandheldLocations = (eid)   => api.get(`/handheld/locations/${eid}`);
export const handheldScan         = (data)  => api.post('/handheld/scan', data);
export const getHandheldScans     = (params)=> api.get('/handheld/session-scans', { params });
export const syncHandheldData     = (data)  => api.post('/handheld/sync', data);

// Conference Reports
export const getAttendanceReport  = (params) => api.get('/conference-reports/attendance', { params });
export const getLocationSummary   = (params) => api.get('/conference-reports/location-summary', { params });
export const getCategorySummary   = (params) => api.get('/conference-reports/category-summary', { params });
export const getDelegateMovements = (id)     => api.get(`/conference-reports/movement/${id}`);
export const getHourlyTraffic     = (params) => api.get('/conference-reports/hourly-traffic', { params });

export default api;
